
import Navigation from '../../components/feature/Navigation';
import Footer from '../../components/feature/Footer';
import SEOHead from '../../components/feature/SEOHead';
import HeroSection from './components/HeroSection';
import ProjectsSection from './components/ProjectsSection';

export default function HomePage() {
  const schemaData = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "Roel & Wietse Creative Team",
    "description": "Crafting compelling stories that connect brands with their audiences through the perfect blend of art direction and copywriting.",
    "url": import.meta.env.VITE_SITE_URL || "https://example.com",
    "logo": "https://static.readdy.ai/image/a470b9cd5371eba9339d500d9617e0ad/cd568f4a1c48e3cd6de29effc1b86ef5.png",
    "sameAs": [],
    "contactPoint": {
      "@type": "ContactPoint",
      "contactType": "customer service",
      "url": `${import.meta.env.VITE_SITE_URL || "https://example.com"}/contact`
    },
    "founder": [
      {
        "@type": "Person",
        "name": "Roel",
        "jobTitle": "Art Director"
      },
      {
        "@type": "Person", 
        "name": "Wietse",
        "jobTitle": "Copywriter"
      }
    ],
    "knowsAbout": ["Art Direction", "Copywriting", "Creative Direction", "Campaign Creation", "Brand Strategy"],
    "serviceArea": {
      "@type": "Place",
      "name": "Netherlands"
    }
  };

  return (
    <div className="min-h-screen">
      <SEOHead
        title="Roel& Wietse : Creative team : Portfolio"
        description="Crafting compelling stories that connect brands with their audiences through the perfect blend of art direction and copywriting. Platform thinking? Art? Copy? Thinkstarters? Extra creativity? Big or small ideas? Lots of purpose or a bit? All of this? Let's connect, we'd love to hear about your project."
        keywords="Creatief team, Creative direction, Ai, Purpose, Art Direction, Copywriting, Campaign creators, Campagne Platform, Experience, online, offline, advertising, reclame, agencies, fresh ideas"
        schemaData={schemaData}
      />
      <Navigation />
      <HeroSection />
      <div data-section="projects">
        <ProjectsSection />
      </div>
      <Footer />
    </div>
  );
}
